"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runCookieNotice = void 0;
var runCookieNotice = function () {
    if (window.localStorage) {
        var hasAccepted = localStorage.getItem('cookieAccepted');
        if (hasAccepted) {
            return;
        }
    }
    var bar = document.querySelector('.cookie-notice');
    if (bar.dataset.visible === 'false') {
        setTimeout(function () { return bar.setAttribute('data-visible', 'true'); }, 4000);
    }
};
exports.runCookieNotice = runCookieNotice;
